import { useQuery } from '@tanstack/react-query';
import { fetchAddressByAddressKey } from '../../utils/apiUtils';
import { useInView } from 'react-intersection-observer'

const HrpAddress = ({ addressKey }) => {

    const { ref, inView } = useInView({
        triggerOnce: true, // Optional: Only trigger the query the first time it enters view
        threshold: 0.1,    // Optional: Triggers when 10% of the element is visible
    })

    const { data, isLoading, error } = useQuery({
        queryKey: ['hrpaddress', addressKey],
        queryFn: async () => {
            const result = await fetchAddressByAddressKey(addressKey);
            return result;
        },
        // select: (data) => data[0],
        staleTime: Infinity,
        enabled: !!(addressKey && addressKey !== 'null') && inView,
    });
    const address = data?.rows?.[0]
    return (
        <>
            {addressKey}
            <br ref={ref} />
            {address?.addressLine} {address?.addressLine2 ? `, ${address?.addressLine2}` : ''}
            <br />
            {address?.cityName},  {address?.stateCode},  {address?.zipCode}
            {/* {address && `
            ${address?.addressLine} ${address?.addressLine2 ? `, ${address?.addressLine2}` : ''}
            ${address?.cityName}  ${address?.stateCode}  ${address?.zipCode}
            `} */}
            {isLoading && 'Loading...'}
            {error && <p className='danger'>{error.messsage}</p>}</>
    )
}

export default HrpAddress